// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"223":"1c3494b607b20769","333":"a804858492f538f1"}[chunkId] + ".css";
};